<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <h1 class="header-style">
        Check-in Types
      </h1>
      <p class="subheader-style">
        Select a check-in type to continue.
      </p>
      <v-btn
        fab
        color="#FFF"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
      <template v-for="(item, i) in checkInTypes">
        <v-col
          :key="i"
          cols="12"
          md="12"
        >
          <v-btn
            class="types-list-style"
            elevation="0"
            @click="toSelectedCheckInProcess(item)"
          >
            {{ item | arrangePretty }}
          </v-btn>
        </v-col>
      </template>
      <center-spinner
        :loading="loading"
      />
    </div>
  </v-dialog>
</template>

  <script>
    import spinner from '../../components/SpinnerCentre.vue';
    export default {
      name: 'CheckInTypes',
      components: {
        'center-spinner': spinner,
      },
      filters: {
        arrangePretty (val) {
        if (val === 'staff') {
          return 'Site Manager';
        } else {
          return val;
        }
      },
      },
      data: () => ({
        loading: false,
        scannedCode: '',
        showModal: true,
      }),
      computed: {
        userSelectedOrganization () {
          return this.$store.getters['organization/getSelectedOrganization'];
        },
        isStoredOrganizationAvailable () {
          if (Object.keys(this.userSelectedOrganization).length > 0) {
            return true;
          }
          return false;
        },
        checkInTypes () {
          if (this.isStoredOrganizationAvailable === true) {
            return this.userSelectedOrganization.types;
          }
          return [];
        },
      },
      watch: {
        showModal: function (newval, oldval) {
          if (newval === false) {
            this.$emit('closed');
          }
        },
      },
      mounted () {
        this.checkSelectedOrganization();
      },
      methods: {
        checkSelectedOrganization () {
          if (this.isStoredOrganizationAvailable === true) {
            return;
          }
          this.loading = true;
          setTimeout(() => {
            this.$router.push({ name: 'CheckIn' });
            this.loading = false;
          }, 1000);
        },
        toSelectedCheckInProcess (type) {
          this.loading = true;
          setTimeout(() => {
            this.$emit('checkin-type-selected', type);
            this.loading = false;
          }, 1000);
        },
      },
    };
  </script>
